import React, { useEffect, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import HighchartsLibOfficial from 'highcharts';
import PropTypes from 'prop-types';
import variablePie from '../../node_modules/highcharts-variable-pie/variable-pie.js';
import { useMonths } from '../../common/utils/datas.js';
const project = require('../../scripts/configs/project.json');

const HighChart = ({ componentConfig }) => {
    const [isVarPie, setIsVarPie] = useState(componentConfig.varPie);
    const [Highcharts, setHighcharts] = useState(false);
    const { months, shortMonths } = useMonths();
    useEffect(() => {
        if (isVarPie && Highcharts) {
            variablePie(Highcharts);
            setIsVarPie(false);
        }
    }, [isVarPie, Highcharts]);
    useEffect(() => {
        if (!Highcharts) {
            const loadDefaultHighchart = function () {
                HighchartsLibOfficial?.setOptions({
                    lang: {
                        months,
                        shortMonths
                    }
                });

                setHighcharts(HighchartsLibOfficial);
            };

            if (
                project.zooming &&
                // componentConfig.options.chart.type !== 'column' &&
                componentConfig.options.chart.type !== 'variablepie' &&
                !navigator.userAgent.toLowerCase().includes('firefox') // Перевірка на Firefox
            ) {
                import('./../highcharts')
                    .then((res) => {
                        setHighcharts(res);
                    })
                    .catch(() => {
                        loadDefaultHighchart();
                    });
            } else {
                loadDefaultHighchart();
            }
        }
    }, [Highcharts, months, shortMonths]);
    if (isVarPie || !Highcharts) return null;

    const withDisabledWatermardConfig = {
        ...componentConfig,
        options: {
            ...componentConfig?.options,
            credits: {
                enabled: false
            }
        }
    };

    return <HighchartsReact highcharts={Highcharts} {...withDisabledWatermardConfig} />;
};

HighChart.propTypes = { componentConfig: PropTypes.object };

export default HighChart;
